<template>
  <span v-bind:class="placeSecondaryWalletInfoButton()" >
    <b-button :id="request.paymentRequestId+'_'+walletType" class="infobutton" href="#" tabindex="0">
      <font-awesome-icon
        class="fa-1x infoicon align-middle text-info"
        :icon="['fas','info-circle']"
      />
    </b-button>
    <b-popover :target="request.paymentRequestId+'_'+walletType" placement="right" triggers="click blur">
      <h6>Following projects have used same wallet id</h6>
      <ul class="list-group">
        <li
          class="list-group-item py-2"
          v-for="ref in getFilterProjectReferences(request)"
          :key="ref.projectId"
        >{{ref.name}}</li>
      </ul>
    </b-popover>
  </span>
</template>
<script>
export default {
  name: "References",
  props: ["request", "walletType", "walletId"],
  methods:{
    getFilterProjectReferences(request){
       let projectReference=[];
       if(this.walletType=="primary")
       {
         projectReference = request.projectReferences.filter((i)=>{ if(i.walletId==this.walletId || i.walletId==null) return i; })
       }
       else{
         projectReference = request.projectReferences.filter((i)=>{ if(i.walletId==this.walletId) return i; })
       }
       return projectReference;    },
    placeSecondaryWalletInfoButton(){
      if(this.walletType=="secondary"){
        return "align-icon secondarywallet"
      }
      else{
        return "align-icon infocontainer"
      }
    }
  }
  
};
</script>

<style>
.align-icon {
  display: inline-block;
  float: right;
}
.infocontainer {
  top: 2px;
  right: 5px;
}
.secondarywallet{
  top: 39px !important;
  right: 5px;
}
</style>